var exports = {
  "mj": "userInput__l-g6cr",
};

module.exports = exports;
